import { FeatureFlagKey, isFeatureEnabled } from "../../config/features";
import { PageEndpointEnum } from "../../enums/endpoint";

export type ReferralTableKey = "reward" | "referral";

/** Referral rewards (Claim + Rewards History) are gated by REFERRAL_REWARDS. */
export const isReferralRewardsEnabled = (): boolean =>
  isFeatureEnabled(FeatureFlagKey.REFERRAL_REWARDS);

/** The `?tab=` values the referrals page accepts; the first is the default. */
export const getReferralTables = (): ReferralTableKey[] =>
  isReferralRewardsEnabled() ? ["referral", "reward"] : ["referral"];

/**
 * Where `/referral-rewards-history` lands. It used to redirect to `?tab=rewards`,
 * a value the page never accepted; `reward` is the real one, and with rewards
 * off the plain referrals page is the only honest destination.
 */
export const getReferralRewardsHistoryPath = (): string =>
  isReferralRewardsEnabled()
    ? `${PageEndpointEnum.REFERRALS}?tab=reward`
    : PageEndpointEnum.REFERRALS;
